import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { usePageTypeContent } from "../../hooks/UseContentHook";
import { DistributedGenerationOverviewPage, DistributedGenerationOverviewPageProps } from "./DistributedGenerationOverviewPage";

export const EMPTY_PAGE_CONTENT: DistributedGenerationOverviewPageProps = {
  pageTitle: "",
};

export const CANONICAL_LINK = "/personal/electricity/distributed-generation";

export const DistributedGenerationOverviewPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = usePageTypeContent<DistributedGenerationOverviewPageProps>("distributed_generation_overview", EMPTY_PAGE_CONTENT);
  if (content.seo) {
    content.seo.canonicalLink = CANONICAL_LINK;
  }
  return <DistributedGenerationOverviewPage {...routeProps} {...content} />;
};
